import type { BasketItem } from '@scayle/storefront-nuxt'
import useTrackingEvents from './tracking/useTrackingEvents'
import useAgsBasket from './useAgsBasket'
import type { TrackAddToWishListParams } from '~/types/tracking'

let singleton: ReturnType<typeof useAgsWishlist>

export default () => {
  if (singleton && import.meta.client) {
    return singleton
  }
  singleton = useAgsWishlist()
  return singleton
}

function useAgsWishlist() {
  const { trackRemoveFromWishlist, trackAddToWishlist } = useTrackingEvents()

  const basket = useAgsBasket()
  const wishlist = useWishlist({}, 'useAgsWishlist')

  const fetch = async () => {
    if (import.meta.server) {
      return
    }

    await Promise.all([basket.fetch(), wishlist.refresh()])
  }

  const addItem = async (
    item: BasketItem,
    index: number,
    type: TrackAddToWishListParams['type'],
  ) => {
    const { product, variant } = item
    await wishlist.addItem({ productId: product.id })
    trackAddToWishlist({ product, variant, index, type })
  }

  const count = computed(() => wishlist.data.value?.items?.length || 0)

  const removeItem = async (item: BasketItem) => {
    const { product, variant } = item
    await wishlist.removeItem({ productId: product.id })
    trackRemoveFromWishlist({ product, variant })
  }

  return {
    data: wishlist.data,
    addItem,
    removeItem,
    replaceItem: wishlist.replaceItem,
    findItem: wishlist.findItem,
    toggleItem: wishlist.toggleItem,
    fetching: wishlist.status.value === 'pending',
    count,
    fetch,
  }
}
